//user-api.js
import axios from 'axios'
import { API_URL } from '@/config/api.config'

const userAPI = {
    /**
     * 获取用户列表（分页）
     */
    getUserList: async (page = 1, perPage = 10) => {
        try {
            const response = await axios.get(`${API_URL}/user`, {
                params: { page, per_page: perPage }
            });
            return response.data;
        } catch (error) {
            console.error('获取用户列表失败:', error);
            throw error;
        }
    },

    /**
     * 获取单个用户详情
     */
    getUserDetail: async (userId) => {
        try {
            const response = await axios.get(`${API_URL}/user/${userId}`);
            return response.data;
        } catch (error) {
            console.error('获取用户详情失败:', error);
            throw error;
        }
    },

    /**
     * 更新用户状态
     */
    updateUserStatus: async (userId, newStatus) => {
        try {
            const response = await axios.put(`${API_URL}/user/${userId}/status`, { status: newStatus });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default userAPI;
